import React from 'react';

interface V1DateQuestionProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  hasError?: boolean;
}

export const V1DateQuestion: React.FC<V1DateQuestionProps> = ({
  value,
  onChange,
  onBlur,
  hasError = false,
}) => {
  return (
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
        hasError ? 'border-red-300' : 'border-gray-300'
      }`}
    />
  );
};